"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEBTOR_EDITS = exports.NEEDS_INTERNAL_REVIEW = exports.NEEDS_REVIEWER_FEEDBACK = exports.NEEDS_DEBTOR_RESPONSE = exports.IS_LEGAL_AID = void 0;
var IS_LEGAL_AID = 'is_legal_aid';
exports.IS_LEGAL_AID = IS_LEGAL_AID;
var NEEDS_DEBTOR_RESPONSE = 'needs_debtor_response';
exports.NEEDS_DEBTOR_RESPONSE = NEEDS_DEBTOR_RESPONSE;
var NEEDS_REVIEWER_FEEDBACK = 'needs_reviewer_feedback';
exports.NEEDS_REVIEWER_FEEDBACK = NEEDS_REVIEWER_FEEDBACK;
var NEEDS_INTERNAL_REVIEW = 'needs_internal_review';
exports.NEEDS_INTERNAL_REVIEW = NEEDS_INTERNAL_REVIEW;
var DEBTOR_EDITS = 'debtor_edits';
exports.DEBTOR_EDITS = DEBTOR_EDITS;